import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { Tooltip } from "@mui/material";
import { Fragment } from "react";

export const CargoTankEquipment = {
	"*": "*",
	"1": "Refrigeration system",
	"2": "Possibility of cargo heating",
	"3": "Water-spray system",
	"4": "Cargo heating system on board",
} as const;

export const ProductCargoTankEquipmentSelect = ({ value, onChange, multiple }: Omit<SelectProps<string, true>, "fetchOptions">) => {
	return <Select
		disableSearch
		fetchOptions={Object.keys(CargoTankEquipment)}
		getOptionLabel={opt => getLabel(opt as keyof typeof CargoTankEquipment)}
		multiple={multiple}
		value={value}
		onChange={onChange}
	/>;
};

// eslint-disable-next-line react-refresh/only-export-components
export function productCargoTankEquipmentField(cargoTankEquipment: string | undefined | null) {
	if (!cargoTankEquipment) {
		return "-";
	}
	const keys = cargoTankEquipment.split(",").filter(s => s in CargoTankEquipment) as Array<keyof typeof CargoTankEquipment>;
	if (keys.length === 0) {
		return "-";
	}
	return (
		<>
			{keys.map((key, i) => (
				<Fragment key={key}>
					{i > 0 && ", "}
					{key === "*"
						? "*"
						: <Tooltip title={CargoTankEquipment[key]} placement="right"><span>{key}</span></Tooltip>}
				</Fragment>
			))}
		</>
	);
}

function getLabel(cargoTankEquipment: keyof typeof CargoTankEquipment) {
	return cargoTankEquipment === "*" ? "*" : `${cargoTankEquipment}. ${CargoTankEquipment[cargoTankEquipment as keyof typeof CargoTankEquipment]}`;
}
